/* eslint-disable import/no-extraneous-dependencies */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import PutImage from '../api/backend/PutChatImageApi';
import GetImage from '../api/backend/GetChatImageApi';

/**
 * @class ImageService
 */
export class ImageService {
  constructor(private idToken: string) {}
  sendImages(channelId: string, files: File[]) {
    return new PutImage(this.idToken).send({
      type: 'put',
      channelId,
      files
    });
  }
  getImage(channelId: string, ...keys: string[]) {
    return new GetImage(this.idToken).get(channelId, ...keys);
  }
}

export default ImageService;
